module.exports = __webpack_public_path__ + "img/Logo-bt-06.4252a540.png";